import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import { BodyText } from "../../shared/text/BodyText.styled";
import { ediphiPalette } from "../../styles/colors";

interface ProjectDetailRowProps {
  label: string;
  value: ReactNode;
}

/**
 * One `Label: value` line of a DetailCard's body, on a single line — the value truncates rather than
 * wrapping, so every row in the project list is the same height.
 *
 * Deliberately not `CardLabeledValue`, which shows the same fields in the project header and lets a
 * long value wrap. Merging them would have to pick one behaviour and one label treatment.
 */
export const ProjectDetailRow: React.FC<ProjectDetailRowProps> = ({ label, value }) => (
  <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5, minWidth: 0 }}>
    <BodyText sx={{ fontWeight: 600, flexShrink: 0 }}>{label}:</BodyText>
    <BodyText sx={{ color: ediphiPalette.mainTextColor, minWidth: 0 }} noWrap>
      {value}
    </BodyText>
  </Box>
);
